import { Helmet } from "react-helmet-async";

export default function Seo({
    title,
    description,
    image = "https://contblack.com.br/logo.png",
    url = window.location.href,
}) {
    const schema = {
        "@context": "https://schema.org",
        "@type": "AccountingService",
        name: "Contblack",
        url: "https://contblack.com.br",
        logo: "https://contblack.com.br/logo.png",
        description,
    };

    return (
        <Helmet>
            <title>{title}</title>

            <meta
                name="description"
                content={description}
            />

            <meta
                property="og:title"
                content={title}
            />

            <meta
                property="og:description"
                content={description}
            />

            <meta
                property="og:image"
                content={image}
            />

            <meta
                property="og:url"
                content={url}
            />

            <meta
                property="og:type"
                content="website"
            />

            <meta
                name="twitter:card"
                content="summary_large_image"
            />

            <script type="application/ld+json">
                {JSON.stringify(schema)}
            </script>
        </Helmet>
    );
}